var Adapter = require('./adapter')
var Util = require('../util')

var StandardAdapter = Adapter.extend(
  /** @lends youbora.StandardAdapter.prototype */
  {
    /**
     * Override to return a json object with the following:
     *
     * [{
      'object': player object that emmits events,
      'suscriber': method of the player object used to register listeners,
      'unsuscriber': method of the player used to unregister listeners,
      'events': {
        event name: adapter method to be called when the event is triggered,
        ...
      }
    }]
     */
    getListenersList: function () {
    },

    /**
     * It calls initializeAdapter and ListenersList getter, to register the methods to the right
     * events keeping a reference list to be able to unregister them.
     * Also registers all of them in the logAllEvents to debug.
     */
    registerListeners: function () {
      if (this._registeredListeners && this._registeredListeners.length != 0) return null
      var listeners = this.getListenersList()
      this._registeredListeners = []
      // Register listeners
      for (var index in listeners) {
        var playerObject = listeners[index]['object']
        if (!playerObject) playerObject = this.player
        var suscriber = listeners[index]['suscriber']
        if (!suscriber) {
          if (typeof playerObject.addEventListener === 'function') {
            suscriber = 'addEventListener'
          } else if (typeof playerObject.on === 'function') {
            suscriber = 'on'
          }
        }
        var unsuscriber = listeners[index]['unsuscriber']
        if (!unsuscriber) {
          if (typeof playerObject.removeEventListener === 'function') {
            unsuscriber = 'removeEventListener'
          } else if (typeof playerObject.off === 'function') {
            unsuscriber = 'off'
          }
        }
        var references = listeners[index]['events']

        // Console all events if logLevel=DEBUG
        var eventList = []
        //get a list for all events of the player
        for (var subindex in references) {
          eventList.push(subindex)
        }
        if (suscriber === "addEventListener" || suscriber === "on") {
          Util.logAllEvents(playerObject, [null].concat(eventList))
        } else {
          Util.logAllEvents(playerObject[suscriber], [null].concat(eventList))
        }

        // register methods
        for (var key in references) {
          if (references[key]) {
            this._registeredListeners.push([playerObject, unsuscriber, key, references[key].bind(this)])
            var position = this._registeredListeners.length - 1
            playerObject[suscriber](key, this._registeredListeners[position][3])
          }
        }
      }
    },

    /**
     * It unregisters everything registered with registerListeners before.
     */
    /** Unregister listeners to this.player. */
    unregisterListeners: function () {
      // Disable playhead monitoring
      this.monitor.stop()
      // Unregister the saved listeners
      if (this._registeredListeners.length === 0) return null
      for (var key in this._registeredListeners) {
        var object = this._registeredListeners[key]
        var playerObject = object[0]
        var unsuscriber = object[1]
        var event = object[2]
        var listener = object[3]
        playerObject[unsuscriber](event, listener)
      }
      this._registeredListeners = []
    }
  }
)

module.exports = StandardAdapter



//////////////////
// WEBPACK FOOTER
// ./~/youboralib/src/adapter/standardadapter.js
// module id = 34
// module chunks = 0